export const MOOG_MINITAUR = [
    {
        'VCO 2': {
            FREQ: 17,
        },
        'FILTER': {
            CUTOFF: 19,
            RES: 21,
            'EG AMOUNT': 22,
        },
        'MIX': {
            'VCO 1 LVL': 15,
            'VCO 2 LVL': 16,
        }
    },
    { 
        'OSCILLATORS': {
            'OSC 1 SHAPE' : 70,
            'OSC 2 SHAPE': 71,
        },
        'MOD': {
            'LFO RATE': 3,
            'VCO LFO AMT': 13,
            'VCF LFO AMT': 12,
        }
    },
    {
        'FILTER ENVELOPE': {
            'ATTACK': 23,
            'DECAY/RELEASE': 24,
            'SUSTAIN': 25,
        },
        'AMP ENVELOPE': {
            'ATTACK': 28,
            'DECAY/RELEASE': 31,
            'SUSTAIN': 30
        }
    }
];

export const ROLAND_SH01A = [
    {
       "VCF": {
            "CUTOFF": 74,
            "RES": 71,
            "ENV DEPTH": 24,
            "MOD DEPTH": 25,
            "KEY FOLLOW": 26,
            "BEND DEPTH": 27,
        },
    },
    {
        "LFO": {
            "RATE": 3,
            "WAVEFORM": 12,
            "MODE": 79,
        },
    },
    {
        "VCO": {
            "MOD DEPTH": 13,
            "RANGE": 14,
            "PULSE WIDTH": 15,
            "PWM SOURCE": 16,
            "MOD SENS": 17,
       }
    },
    {
        "VCO": {
            "BEND DEPTH": 18,
            "PWM LEVEL": 19,
            "SAW LEVEL": 20,
            "SUB LEVEL": 21,
            "SUB TYPE": 22,
            "NOISE LEVEL": 23,
        }
    },
    {
        "ENV": {
            "ATTACK": 73,
            "DECAY": 75,
            "SUSTAIN": 30,
            "RELEASE": 72
        }, 
        "VCA": {
            "ENV SW": 28,
            "ENV MODE": 29,
        },
    },
    {
        "PORTAMENTO": {
            "PORTAMENTO MODE": 31,
            "PORTAMENTO": 65,
            "PORTAMENTO TIME": 5,
        } ,
           "MISC": {
            "TRANSPOSE SW": 77,
            "NOISE MODE": 78,
            "TUNE": 76
        }
    }
];

export const KORG_MONOLOGUE = [
    {
       "EG": {
            "ATTACK": 16,
            "DECAY": 17,
            "INT": 18,
            "TYPE": 61,
            "TARGET": 62,
       },
    },
    {
        "LFO": {
            "RATE": 24,
            "DEPTH": 26,
            "TARGET": 56,
            "WAVE": 58,
            "MODE": 59,
        },
    },
    {
        "VCO 1": {
            "SHAPE": 36,
            "LEVEL": 39,
            "WAVE": 50,
            "SYNC/RING": 60,
        },
    },
    {
        "VCO 2": {
            "PITCH": 35,
            "SHAPE": 37,
            "LEVEL": 40,
            "WAVE": 51,
            "OCTAVE": 49,
        },
    },
   {
        "FILTER": {
            "CUTOFF": 43,
            "RESONANCE": 44,
            "DRIVE": 28,
        }, 
    },
];

// midi_mix can be devied into 8 groups/tracks w/
// a volume slider, 3 effect knobs and 2 buttons
export const MIDI_MIX = {
    note: {
        0: {
            PATTERN_SWITCH: 1,
            SEQUENCE_ROLL: 3,
            PREVIOUS_PATTERN: 25,
            NEXT_PATTERN: 26,
        },
        1: {
            PATTERN_SWITCH: 4,
            SEQUENCE_ROLL: 6,
        },
        2: {
            PATTERN_SWITCH: 7,
            SEQUENCE_ROLL: 9,
        },
        3: {
            PATTERN_SWITCH: 10,
            SEQUENCE_ROLL: 12,
        },
        4: {
            PATTERN_SWITCH: 13,
            SEQUENCE_ROLL: 15,
        },
        5: {
            PATTERN_SWITCH: 16,
            SEQUENCE_ROLL: 18,
        },
        6: {
            PATTERN_SWITCH: 19,
            SEQUENCE_ROLL: 21,
        },
        7: {
            PATTERN_SWITCH: 22,
            SEQUENCE_ROLL: 24,
        }
    }, 
    cc: {
        0: { // track/group 1
            KNOB_1: 16,
            KNOB_2: 17,
            KNOB_3: 18,
            VOLUME: 19
        },
        1: { // track/group 2
            KNOB_1: 20,
            KNOB_2: 21,
            KNOB_3: 22,
            VOLUME: 23,
        },
        2: { // track/group 3
            KNOB_1: 24,
            KNOB_2: 25,
            KNOB_3: 26,
            VOLUME: 27,
        },
        3: {
            KNOB_1: 28,
            KNOB_2: 29,
            KNOB_3: 30,
            VOLUME: 31,
        },
        4: {
            KNOB_1: 46,
            KNOB_2: 47,
            KNOB_3: 48,
            VOLUME: 49,
        },
        5: {
            KNOB_1: 50,
            KNOB_2: 51,
            KNOB_3: 52,
            VOLUME: 53
        },
        6: {
            KNOB_1: 54,
            KNOB_2: 55,
            KNOB_3: 56,
            VOLUME: 57,
        },
        7: {
            KNOB_1: 58,
            KNOB_2: 59,
            KNOB_3: 60,
            VOLUME: 61,
        },
        MASTER: 62,
    },
};

export const NATIVE_M_32 = {
    actions: {
        PLAY: 94,
        RECORD: 95,
        CLEAR: 93,
    },
};

export const NATIVE_M_32_CC = {
    ccActions: {
        CHANGE_SELECTED_TRACK: 19,
        BROWSE_SOUNDS: 14,
        CHANGE_START_SLICE: 15,
        CHANGE_END_SLICE: 16,
        CHANGE_TRANSPOSE: 17,
        CHANGE_VOLUME: 18,
    },
};

export const MPD_218 = {
    ccActions: {
        CHANGE_SELECTED_TRACK: 3,
        BROWSE_SOUNDS: 9,
        CHANGE_START_SLICE: 12,
        CHANGE_END_SLICE: 13,
        CHANGE_TRANSPOSE: 15,
        CHANGE_VOLUME: 14,
    },
}

export const DEVICE_TO_CONFIG = {
    'Moog Minitaur' : MOOG_MINITAUR,
    'Boutique SH-01A': ROLAND_SH01A,
};

export const DEVICE_TO_SLIDER_CONFIG = {
    'MIDI Mix': MIDI_MIX,
    'Komplete Kontrol M DAW': NATIVE_M_32,
    //'KOMPLETE KONTROL M32': NATIVE_M_32_CC,
    'MPD218 Port A': MPD_218
}
